import {
  ChatThreadModel,
  ChatThreadModelPagedList,
  DeleteThreadRequest,
  GetAllUserThreadsRequest,
  GetThreadByIdRequest,
  InitOverrideFunction,
  ThreadApi,
} from "../../../@api";

export class ThreadApiService
  implements Omit<ThreadApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: ThreadApi) {}

  public async deleteThread(requestParameters: DeleteThreadRequest): Promise<void> {
    return this.api.deleteThread(requestParameters);
  }
  public async getAllUserThreads(
    requestParameters: GetAllUserThreadsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ChatThreadModelPagedList> {
    return this.api.getAllUserThreads(requestParameters, initOverrides);
  }

  public async getThreadById(requestParameters: GetThreadByIdRequest): Promise<ChatThreadModel> {
    return this.api.getThreadById(requestParameters);
  }
}
